import pick from "lodash/pick"
import flatten from "lodash/flatten"

const createFormUrl = (portalId, formId) =>
  `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`

const formatFields = fields =>
  fields.map(field => {
    if (Array.isArray(field)) {
      return formatFields(field)
    }
    return pick(field, ["name", "value"])
  })

export const postForm = async (options = {}) => {
  const { portalId, formId, data, context } = options
  const fields = flatten(formatFields(data))
  const formatted = {
    fields,
    context,
  }
  const url = createFormUrl(portalId, formId)
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formatted),
  })
  return response.json()
}
